// TODO: WILL REFACT TEMPLATE
<template>
  <div class="integration-element">
    <div class="left-element">
      <div class="icon-wrapper">
        <svg
          v-if="icon === 'arrow-2'"
          class="icon-arrow-1"
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="40"
          viewBox="0 0 1024 1024"
        >
          <path
            d="M281.344 215.373c-11.961 11.962-31.367 11.962-43.336 0l-229.032-229.04c-11.969-11.962-11.969-31.366 0-43.334 5.984-5.984 13.828-8.976 21.672-8.976 7.836 0 15.68 2.992 21.664 8.976l229.032 229.03c11.977 11.968 11.977 31.376 0 43.344zM1015.024 949.022c-5.882 5.883-13.859 9.063-22.218 8.977l-382.15-6.883c-12.294-0.227-23.264-7.773-27.866-19.172s-1.946-24.453 6.749-33.141l82.502-82.5-441.378-441.375c-5.742-5.75-8.977-13.549-8.977-21.674s3.227-15.92 8.977-21.67l166.914-166.899c5.984-5.984 13.83-8.976 21.664-8.976 7.843 0 15.69 2.992 21.674 8.976l441.366 441.366 82.509-82.499c8.688-8.694 21.744-11.35 33.142-6.749s18.944 15.568 19.162 27.866l6.899 382.134c0.147 8.313-3.085 16.336-8.97 22.219zM41.805 112.077c7.844 0 15.687 2.998 21.664 8.982l134.43 134.422c11.969 11.968 11.969 31.376 0 43.344-11.969 11.962-31.367 11.962-43.336 0l-134.43-134.429c-11.969-11.968-11.969-31.376 0-43.344 5.984-5.978 13.828-8.976 21.672-8.976zM321.478 131.898l-134.439-134.422c-11.969-11.968-11.969-31.373 0-43.344 5.984-5.984 13.828-8.976 21.672-8.976s15.687 2.992 21.672 8.976l134.43 134.432c11.968 11.968 11.968 31.373 0 43.334-11.968 11.968-31.376 11.968-43.334 0z"
          />
        </svg>

        <svg
          v-if="icon === 'arrow-1'"
          class="arrow-1"
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="40"
          viewBox="0 0 1024 1024"
        >
          <path
            d="M281.344 680.627c-11.961-11.961-31.367-11.961-43.336 0l-229.032 229.04c-11.969 11.961-11.969 31.367 0 43.336 5.984 5.984 13.828 8.977 21.672 8.977 7.836 0 15.68-2.992 21.664-8.977l229.032-229.032c11.977-11.969 11.977-31.375 0-43.344zM1015.024-53.021c-5.882-5.885-13.859-9.062-22.218-8.976l-382.15 6.88c-12.294 0.227-23.264 7.776-27.866 19.174s-1.946 24.451 6.749 33.139l82.502 82.499-441.378 441.376c-5.742 5.75-8.977 13.549-8.977 21.674s3.227 15.92 8.977 21.67l166.914 166.9c5.984 5.984 13.83 8.977 21.664 8.977 7.843 0 15.69-2.992 21.674-8.977l441.366-441.367 82.509 82.499c8.688 8.694 21.744 11.35 33.142 6.749s18.944-15.568 19.162-27.866l6.899-382.134c0.147-8.314-3.085-16.336-8.97-22.218zM41.805 783.924c7.844 0 15.687-3 21.664-8.984l134.43-134.422c11.969-11.967 11.969-31.375 0-43.343-11.969-11.962-31.367-11.962-43.336 0l-134.43 134.429c-11.969 11.969-11.969 31.375 0 43.344 5.984 5.977 13.828 8.977 21.672 8.977zM321.478 764.101l-134.439 134.422c-11.969 11.969-11.969 31.375 0 43.344 5.984 5.984 13.828 8.977 21.672 8.977s15.687-2.992 21.672-8.977l134.43-134.43c11.968-11.969 11.968-31.375 0-43.336-11.968-11.969-31.376-11.969-43.334 0z"
          />
        </svg>
        <svg
          v-if="icon === 'chat-1-1'"
          class="chat-1-1"
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="40"
          viewBox="0 0 1000 1000"
        >
          <path
            d="M448.009 959.956c-247.025 0-447.974-163.639-447.974-364.78 0-101.882 51.197-197.427 141.56-266.162-29.886-46.652-68.54-93.883-117.305-105.912-15.423-3.84-25.727-18.432-24.127-34.238 1.6-15.872 14.591-28.097 30.526-28.798 0.704 0 3.456-0.13 8.064-0.13 33.086 0 160.823 5.313 305.775 80.507 33.214-6.719 67.963-10.047 103.481-10.047 246.962 0 447.976 163.638 447.976 364.779s-201.014 364.78-447.976 364.78zM999.665 1.494c-40.767 10.047-71.614 39.87-93.181 69.436 75.068 58.811 117.498 139.704 117.498 225.906 0 72.186-30.334 138.55-80.7 191.605-56.892-184.886-257.009-322.03-495.267-322.03-31.807 0-63.229 2.43-93.753 7.231-18.176-8.767-35.966-16.51-53.438-23.422 64.573-99.195 192.308-166.966 339.18-166.966 30.015 0 59.133 2.75 86.781 8.126 91.835-46.782 175.607-55.419 224.882-55.356 27.006 0 43.646 2.56 45.502 2.879 14.974 2.434 26.175 15.104 26.814 30.271 0.575 15.167-9.535 28.735-24.317 32.319z"
          />
        </svg>
        <svg
          v-if="icon === 'checklist-1'"
          class="checklist-1"
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="40"
          viewBox="0 0 1024 1024"
        >
          <path
            d="M696.727 869.439c-5.895 8.262-13.689 14.988-22.724 19.61-9.038 4.622-19.052 7.006-29.202 6.95h-265.599c-10.143 0-20.138-2.41-29.166-7.031-9.026-4.621-16.826-11.322-22.756-19.55s-9.819-17.747-11.349-27.772c-1.527-10.026-0.652-20.271 2.557-29.892l14.207-42.667c4.248-12.741 12.399-23.824 23.295-31.676 10.898-7.853 23.988-12.078 37.42-12.078h237.185c13.432 0 26.522 4.225 37.42 12.078 10.895 7.853 19.046 18.935 23.295 31.676l14.207 42.667c3.262 9.616 4.169 19.876 2.639 29.914s-5.448 19.563-11.428 27.771zM320 512h64.020v-64h-64.020v64zM768.009 832h-16.425c-0.056-11.458-1.928-22.835-5.547-33.707l-14.295-42.667c-7.033-21.254-20.594-39.747-38.748-52.847-18.157-13.1-39.983-20.138-62.37-20.113h-237.226c-22.39-0.025-44.213 7.013-62.37 20.113s-31.715 31.593-38.751 52.847l-14.293 42.667c-3.62 10.871-5.492 22.248-5.547 33.707h-16.426c-28.29 0-55.421-11.238-75.425-31.242s-31.242-47.135-31.242-75.425v-618.668c0-28.289 11.238-55.419 31.242-75.425 20.004-20.003 47.135-31.241 75.425-31.241h511.999c14.008 0 27.879 2.759 40.82 8.119 12.943 5.36 24.702 13.218 34.605 23.122 9.906 9.906 17.762 21.665 23.122 34.605 5.363 12.943 8.122 26.814 8.122 40.82v618.668c0 14.007-2.759 27.878-8.122 40.82-5.36 12.941-13.215 24.7-23.122 34.605-9.904 9.905-21.662 17.762-34.605 23.123-12.94 5.36-26.811 8.119-40.82 8.119zM490.677 554.666h192c5.655 0 11.083-2.247 15.085-6.246 3.999-4.002 6.246-9.427 6.246-15.085s-2.247-11.086-6.246-15.085c-4.002-4.002-9.43-6.249-15.085-6.249h-192c-5.658 0-11.086 2.247-15.085 6.249-4.002 3.999-6.249 9.427-6.249 15.085s2.247 11.083 6.249 15.085c3.999 3.999 9.427 6.246 15.085 6.246zM422.409 264.534l-64-85.334c-1.829-2.455-4.163-4.488-6.846-5.96s-5.652-2.349-8.704-2.575h-1.516c-5.658 0.003-11.083 2.25-15.082 6.252l-42.667 42.666c-3.886 4.023-6.036 9.412-5.988 15.006s2.292 10.945 6.248 14.901c3.955 3.956 9.306 6.2 14.9 6.246 5.594 0.050 10.983-2.101 15.006-5.986l25.278-25.281 49.24 65.665c1.679 2.241 3.786 4.128 6.197 5.556s5.079 2.367 7.853 2.762c2.774 0.395 5.597 0.243 8.312-0.453 2.712-0.693 5.263-1.916 7.504-3.599s4.128-3.786 5.556-6.197c1.428-2.411 2.367-5.079 2.762-7.853 0.398-2.774 0.243-5.597-0.453-8.312-0.693-2.715-1.916-5.263-3.599-7.504zM426.677 448c0-11.317-4.497-22.168-12.499-30.17s-18.853-12.496-30.17-12.496h-64c-11.314 0-22.168 4.494-30.169 12.496s-12.497 18.853-12.497 30.17v64c0 11.317 4.495 22.168 12.497 30.17s18.855 12.496 30.169 12.496h64c11.317 0 22.168-4.494 30.17-12.496s12.499-18.853 12.499-30.17v-64zM725.343 170.666h-234.666c-5.658 0-11.086 2.25-15.085 6.249-4.002 3.999-6.249 9.427-6.249 15.085s2.247 11.086 6.249 15.085c3.999 3.999 9.427 6.249 15.085 6.249h234.666c5.658 0 11.083-2.25 15.085-6.249 3.999-3.999 6.249-9.427 6.249-15.085s-2.25-11.086-6.249-15.085c-4.002-3.999-9.427-6.249-15.085-6.249zM469.343 277.334c0 5.658 2.247 11.083 6.249 15.085 3.999 3.999 9.427 6.246 15.085 6.246h192c5.655 0 11.083-2.247 15.085-6.246 3.999-4.002 6.246-9.427 6.246-15.085s-2.247-11.086-6.246-15.085c-4.002-4.002-9.43-6.249-15.085-6.249h-192c-5.658 0-11.086 2.247-15.085 6.249-4.002 3.999-6.249 9.427-6.249 15.085zM725.343 426.666h-234.666c-5.658 0-11.086 2.25-15.085 6.249-4.002 3.999-6.249 9.427-6.249 15.085s2.247 11.086 6.249 15.085c3.999 3.999 9.427 6.249 15.085 6.249h234.666c5.658 0 11.083-2.25 15.085-6.249 3.999-3.999 6.249-9.427 6.249-15.085s-2.25-11.086-6.249-15.085c-4.002-3.999-9.427-6.249-15.085-6.249z"
          />
        </svg>
      </div>
    </div>

    <div class="right-elemen">
      <div class="count-wrapper">
        <span v-if="typeof count === 'number'" class="count">
          {{ count }}
        </span>
        <div v-else class="spinner"></div>
      </div>

      <div class="info-wrapper">
        <p class="info">{{ $t(`${info}`) }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      require: true,
    },

    count: {
      type: Number,
      require: true,
    },

    info: {
      type: String,
      require: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.checklist-1 {
  transform: rotateX(180deg);
  fill: #7a70df;
  width: 32px;
}
.chat-1-1 {
  transform: rotateX(180deg);
  width: 32px;
  fill: #7a70df;
}
.arrow-1 {
  width: 32px;
  fill: #7a70df;
}
.icon-arrow-1 {
  width: 32px;
  fill: #7a70df;
}
.integration-element {
  padding: 25px;
  flex: 1;

  display: flex;
  align-items: flex-start;
  gap: 21px;
  min-width: 240px;
  background: linear-gradient(
    180deg,
    rgba(122, 112, 223, 0.15) 0%,
    rgba(243, 243, 243, 0) 100%
  );
  box-shadow: inset 0 6px 10px rgba(122, 112, 223, 0.07);
  border-radius: 11px;
}

.left-element {
  min-width: 75px;
  height: 75px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 9px;
  box-shadow: 0 10px 13px rgba(122, 112, 223, 0.22);
  background-color: white;

  span {
    font-size: 32px;
    color: #7a70dfff;
  }
}

.right-elemen {
  flex: inherit;
  display: flex;
  flex-direction: column;
  gap: 14px;

  .count-wrapper {
    .count {
      font-size: 48px;
      line-height: 36px;
      font-family: Gilroy;
      font-weight: 700;
      cursor: default;
      color: #7a70dfff;
    }
  }

  .info-wrapper {
    font-size: 16px;
    font-family: Gilroy;
    font-weight: 500;
    color: black;

    .info: {
      cursor: default;
    }
  }
}
// level with the 32px count it stands in for
.spinner {
  height: 32px;
  width: 32px;
  margin: 0;
  border-width: 4px;
}
@media screen and (max-width: 1024px) {
  .integration-element {
    flex: 0 0 calc(100% - 50px);
  }
}
</style>
